module.exports = __webpack_public_path__ + "static/media/gaven.27e9ea73.jpg";